export type ContactPayload = {
  name: string;
  company: string;
  contact: string;
  direction: string;
  message: string;
  consent: boolean;
};

export type ValidationResult = {
  valid: boolean;
  errors: Partial<Record<keyof ContactPayload, string>>;
};

const contactPattern = /@|1[3-9]\d{9}|weixin|微信|vx|WX/i;
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateContactForm(payload: ContactPayload): ValidationResult {
  const errors: ValidationResult["errors"] = {};

  if (payload.name.trim().length < 2) {
    errors.name = "请填写至少 2 个字的姓名或称呼。";
  }

  if (!contactPattern.test(payload.contact.trim())) {
    errors.contact = "请填写邮箱、手机号或微信号，方便后续联系。";
  }

  if (!payload.direction) {
    errors.direction = "请选择一个关注方向。";
  }

  if (payload.message.trim().length < 8) {
    errors.message = "请简要描述你的背景、目标或当前问题。";
  }

  if (payload.message.length > 1000) {
    errors.message = "说明内容不能超过 1000 字。";
  }

  if (!payload.consent) {
    errors.consent = "请先阅读并同意用户服务协议和隐私政策。";
  }

  return {
    valid: Object.keys(errors).length === 0,
    errors
  };
}

export function validateUpgradeReservationEmail(email: string): string {
  const value = email.trim();

  if (!value) {
    return "请输入你的邮箱。";
  }

  if (!emailPattern.test(value)) {
    return "请输入有效邮箱。";
  }

  return "";
}
